import React from 'react';
import renderHTML from 'react-render-html';
import Autolinker from 'autolinker';
import axios from 'axios';
import { Carousel } from '../../carousel';
import { Container, Tweet } from '../styles/fan-choice.style';
import { isMobile } from '../../../utils/adaptive';
import { getViewport, generateImageUrl } from '../../../utils/webp';
import { BlueButton, BackgroundContainer, RTE } from '../../../utils/atoms';
import { TitleImage } from '../../title-image';

/**
 * Fan Choice component
 */
class FanChoice extends React.Component {
  /**
   * Fan Choice constructor
   * @param {object} props Incoming Props
   */
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      value: '',
      isMobileLocal: false,
      viewportWidth: 2400,
    };
  }

  /**
   * Set viewport width on mount
   */
  componentWillMount() {
    if (typeof window !== 'undefined' && window) {
      this.setState({ viewportWidth: getViewport() });
    }
  }

  /**
   * Sets mobile state if SVP
   */
  componentDidMount() {
    const stateToSet = {};

    const token = '91e0612dec12adb1b69664eed03e7a5e';
    const topic = 'xfl.com%3Acontext%3Dsocialwall';
    const filter = 'featured';
    const limit = 3;
    // TODO: Move URL to site metadata
    const fanKaveUrl = 'https://api.fankave.com/v1.0/cms/content/social'
      + `?token=${token}&topic=${topic}&filter=${filter}&limit=${limit}`;

    axios
      .get(fanKaveUrl)
      // DEV API Below. TODO: Add URL resolving bases on env
      // .get('https://devapi.fankave.com/v1.0/cms/content/social?'
      //  + 'topic=xfl.com:context%3Dsocialwall&filter=featured&limit=3')
      .then((response) => {
        this.setState({ tweets: response.data });
      });
    if (isMobile()) {
      stateToSet.isMobileLocal = true;
    }
    this.setState({ ...stateToSet });
  }

  /**
   * Sets state on key change
   * @param {object} event Event listener
   */
  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  /**
   * Handles submit of the signup form
   * @param {object} event Submit event
   * @param {string} hashtag main Hash Tag
   * @param {string?} customHashtag Hash Tag
   * @param {string?} tweetPretext tweet custom text
   */
  handleSubmit(event, hashtag, customHashtag, tweetPretext) {
    const { value } = this.state;
    event.preventDefault();
    const content = encodeURIComponent(`${tweetPretext || ''}${value || ''}`)
                  + encodeURI(`&hashtags=${hashtag}${customHashtag}`);
    // TODO: Move URL to site metadata
    window.open(`https://twitter.com/intent/tweet?text=${content}`, '_blank');
  }

  /**
   * Render component
   * @returns {JSX} Component JSX
   */
  render() {
    const {
      value,
      isMobileLocal,
      viewportWidth,
      tweets = [],
    } = this.state;
    const {
      background,
      customHashtag,
      tweetPretext,
      childContentfulTwitterDescriptionTextNode,
      placeholder,
      buttonText,
      titleImage,
      twitterHashTag,
      twitterCharacterLimit,
    } = this.props;
    const bkgd = background && background.file && background.file.url;

    const hashtag = twitterHashTag || 'XFL';
    const tweetPretextLength = (tweetPretext && tweetPretext.length) || 0;
    const hashTagLength = hashtag.length + 2 + ((customHashtag && customHashtag.length) || 0); // +2 whitespace and #
    const maxAvailableLength = (twitterCharacterLimit || 280) - tweetPretextLength - hashTagLength;

    const remainingCharacterNumber = maxAvailableLength - value.length;
    const hint = (
      <div className="hint">
        {remainingCharacterNumber}
        {'/'}
        {twitterCharacterLimit || 280}
      </div>
    );

    return (
      <BackgroundContainer src={generateImageUrl(bkgd, viewportWidth)} position="top right">
        <Container>
          <h1 className="section-title" id="share">
            <TitleImage src={titleImage && titleImage.file && titleImage.file.url} alt="Fan Voice" />
          </h1>
          <h2 className="hashtag">
            {`#${hashtag}`}
            <span className="bright">{customHashtag}</span>
          </h2>
          {childContentfulTwitterDescriptionTextNode
            && childContentfulTwitterDescriptionTextNode.childMarkdownRemark && (
            <RTE className="fan-choice__description">
              {renderHTML(childContentfulTwitterDescriptionTextNode.childMarkdownRemark.html)}
            </RTE>
          )}
          <form
            className="tweet-form"
            id="tweet"
            onSubmit={(e) => {
              this.handleSubmit(e, hashtag, customHashtag, tweetPretext);
            }}
          >
            <div className="input-wrapper">
              <input
                type="text"
                maxLength={maxAvailableLength}
                value={value}
                onChange={this.handleChange}
                aria-label={placeholder}
                placeholder={placeholder}
              />
              {remainingCharacterNumber < 50 && hint}
            </div>
            <BlueButton
              className="tweetBtn"
              type="button"
              to="#"
              onClick={(e) => {
                this.handleSubmit(e, hashtag, customHashtag, tweetPretext);
              }}
            >
              <span>{buttonText}</span>
            </BlueButton>
          </form>
          {!isMobileLocal && (
            <Carousel className="tweet-list equal-height" numSlides={3} tabletSlides={2} hideArrows>
              {(tweets || []).map((tweet, index) => (
                <Tweet key={index} className={index % 2 === 1 ? 'alt' : ''}>
                  <div className="tweet-list__header">
                    <img src="/images/twitter-blue.svg" className="twitter-icon" alt="Twitter logo" />
                    <img
                      alt="profile icon"
                      src={tweet.author.photo ? tweet.author.photo : '/images/twitter-default.jpg'}
                      className="profile-icon"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/images/twitter-default.jpg';
                      }}
                    />
                    <h1>{tweet.author.name}</h1>
                    <span
                      className="handle"
                      dangerouslySetInnerHTML={{
                        __html: Autolinker.link(`@${tweet.author.alias}`, {
                          className: 'twitter-link',
                          mention: 'twitter',
                          hashtag: 'twitter',
                        }),
                      }}
                    />
                  </div>
                  <div className="tweet-list__body">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: Autolinker.link(tweet.text, {
                          className: 'twitter-link',
                          mention: 'twitter',
                          hashtag: 'twitter',
                        }),
                      }}
                    />
                  </div>
                </Tweet>
              ))}
            </Carousel>
          )}
        </Container>
      </BackgroundContainer>
    );
  }
}

export default FanChoice;



// WEBPACK FOOTER //
// ./src/components/fan-choice/components/fan-choice.js